import { Box } from "@mui/material";
import Header from "../../components/shared/header/Header";
import HorizontalTabs from "../../components/shared/horizontal-tab";
import { observer } from "mobx-react-lite";
import ExecutorSharedView from "../shared/ExecutorSharedView";
import UnconfirmedTransfer from "../../components/executor/transfers/UnconfirmedTransfer";
import ConfirmedTransfer from "../../components/executor/transfers/ConfirmedTransfer";

export default observer(function Transfers() {
  return (
    <ExecutorSharedView
      mainContent={
        <Box
          sx={{
            p: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Direct Transfers Manager" />
          </Box>

          <HorizontalTabs
            tabNames={["unconfirmed", "confirmed"]}
            tabContents={[<UnconfirmedTransfer />, <ConfirmedTransfer />]}
          />
        </Box>
      }
    />
  );
});
